const ALL = 'input[data-clearable]';
const CLEAR_ICON = '.clear-icon';

const clearInputInit = (inputToClear) => {
  // When the clear input button is clicked, clear and focus the search input
  let clearButton = inputToClear.parentElement.querySelector(CLEAR_ICON);
  clearButton.addEventListener('click', function(event){
    event.stopPropagation();
    inputToClear.value = '';
    inputToClear.dispatchEvent(new Event('input'));
    inputToClear.focus();
  })
}

// Expose a simple function for selecting all dropdowns with search currently present in the DOM,
const attachAll = () => {
  document.querySelectorAll(ALL).forEach((inputToClear) => {
    clearInputInit(inputToClear);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      // Observe mutations on elements that include a dropdown
      mutation.target.querySelectorAll(ALL).forEach((inputToClear) => {
        clearInputInit(inputToClear);
      })

      // Observe mutations directly on dropdowns
      if (mutation.target.matches(ALL)) {
        clearInputInit(mutation.target);
      }
    })
  })

  observer.observe(document.body, { childList: true, subtree: true });
}

export default { attachAll }
